import { SlideOrderForm, type SlideOrderProps } from '../slides/SlideOrderForm';

/** Native benefits-slide product backed by the published infog workflow. */
export function InfogOrderForm(props: SlideOrderProps) {
  return <SlideOrderForm {...props} kind="infog" />;
}
